// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607200832/js/" + chunkId + "." + {"44":"f3624647","225":"41632b84","481":"cc165944","486":"1ee38eaf","770":"d90dc2e8"}[chunkId] + ".0.9105067758221359.chunk.js";
};